import React, { useEffect } from 'react';
import { useParams, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGUAGES = ['fr', 'ar'];
const DEFAULT_LANGUAGE = 'fr';

const LanguageWrapper: React.FC = () => {
    const { lang } = useParams<{ lang: string }>();
    const { i18n } = useTranslation();
    const location = useLocation();

    useEffect(() => {
        if (lang && SUPPORTED_LANGUAGES.includes(lang)) {
            if (i18n.language !== lang) {
                i18n.changeLanguage(lang);
                document.documentElement.lang = lang;
                document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
            }
        }
    }, [lang, i18n]);

    // If language is not supported, redirect to default language
    // We need to be careful not to cause an infinite loop if the URL structure is completely wrong
    // But since this component is rendered under /:lang, 'lang' should be present.
    if (!lang || !SUPPORTED_LANGUAGES.includes(lang)) {
        // Construct the new path with the default language
        // If the current path is something like /es/chat, we want to go to /fr/chat
        // If it's just /chat (which shouldn't match /:lang but might if we are not careful), we prepend default

        // However, since we will use this in a route like path="/:lang"
        // The param 'lang' will capture the first segment.

        // Preserve query string when redirecting to default language
        return <Navigate to={`/${DEFAULT_LANGUAGE}${location.pathname.replace(/^\/[^/]+/, '')}${location.search}`} replace />;
    }

    return <Outlet />;
};

export default LanguageWrapper;
